const STATIC_MARKETING_ROUTES = new Set([
  "/",
  "/about",
  "/accessibility",
  "/brunch",
  "/catering",
  "/colab",
  "/contact",
  "/faq",
  "/matcha",
  "/menu",
  "/privacy-policy",
  "/salt-bread",
  "/terms-and-conditions",
  "/visit",
])

export function shouldBypassMedusaRegionLoader(pathname: string) {
  const normalized = pathname.replace(/\/+$/, "") || "/"
  const withoutCountry = normalized.replace(/^\/[a-z]{2}(?=\/|$)/i, "") || "/"

  return STATIC_MARKETING_ROUTES.has(withoutCountry)
}
